export default {"src":"/_next/static/media/x-logo.5b555eef.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};